export const AppRoutes = {
	loopApp: '/loop-app',
	archibaldLondon: '/archibald-london',
	coinmunitee: '/coinmunitee',
	home: '/'
};